(() => {
  if (typeof window.customElements.get('locations-section') !== 'undefined') { return }
  window.customElements.define('locations-section', class LocationsSection extends HTMLElement { // eslint-disable-line
    constructor() {
      super()
      this.list = this.querySelector('[data-locations-list]')
      this.listWrapper = this.querySelector('[data-locations-list-wrapper]')
      this.mapEl = this.querySelector('[data-locations-map]')
      this.mapWrapper = this.querySelector('[data-locations-map-wrapper]')
      this.toggleLists = this.querySelectorAll('[data-toggle-list]')
      this.toggleMaps = this.querySelectorAll('[data-toggle-map]')
      this.resultsCount = this.querySelector('[data-results-count]')
      this.submit = this.querySelector('[data-locations-submit]')
      this.form = this.querySelector('[data-locations-form]')
      this.input = this.querySelector('[data-locations-input]')
      this.clickTime = Date.now() - 1001
      this.allLocations = []
      this.map = null
      this.range = 50000
      this.autocomplete = null
      this.infowindow = null
      this.customerLocation = []
      this.loc = []
      this.attempts = 0
      this.prefLocation = 0
      this.initToggles()
      this.init()
      this.checkToken()
    }

    async init() {
      this.allLocations = await this.getLocations();
      if (!this.allLocations) { return }

      await this.initMap()
      this.getLocation()

      if (localStorage.getItem('mapsPlace')) {
        const mapsPlace = JSON.parse(localStorage.getItem('mapsPlace'))
        this.updateCenter(mapsPlace)
        this.input.value = mapsPlace.name
        localStorage.removeItem('mapsPlace')
      }

      this.autocomplete = new google.maps.places.Autocomplete(this.input);
      this.autocomplete.setComponentRestrictions({ country: ['ca'] });
      this.autocomplete.addListener('place_changed', this.updateCenter.bind(this));

      this.form.addEventListener('submit', (event) => {
        event.preventDefault()
        this.submitInput()
      })
    }

    submitInput() {
      if (!this.input.value || this.input.value === '') { return }
      this.placesService = new google.maps.places.PlacesService(document.createElement('div'));
      this.autocompleteService = new google.maps.places.AutocompleteService();

      const request = {
        input: this.input.value,
        componentRestrictions: {
          country: 'ca'
        }
      }

      this.autocompleteService.getPlacePredictions(request, (predictions, status) => {
        if (status !== 'OK') { console.error('Autocomplete request failed with status: ' + status) }

        this.placesService.getDetails({ placeId: predictions[0].place_id }, (place, detailStatus) => {
          if (detailStatus !== google.maps.places.PlacesServiceStatus.OK) { return }
          this.updateCenter(place)
        });
      })
    }

    initToggles() {
      this.toggleLists.forEach(toggleList => {
        toggleList.addEventListener('click', () => {
          this.toggleElements('list')
        })
      })

      this.toggleMaps.forEach(toggleMap => {
        toggleMap.addEventListener('click', () => {
          this.toggleElements('map')
        })
      })
    }

    toggleElements(type) {
      this.toggleLists.forEach(toggleList => {
        toggleList.classList.toggle('hide', type === 'list')
      })
      this.toggleMaps.forEach(toggleMap => {
        toggleMap.classList.toggle('hide', type === 'map')
      })
      this.listWrapper.classList.toggle('active', type === 'list')
      this.mapWrapper.classList.toggle('active', type === 'map')
    }

    checkToken() {
      if (!window.locations.is_customer) { return }

      const tokenString = localStorage.getItem('LRTokenKey')
      if (tokenString) {
        this.fetchPreferedClinic(tokenString)
      } else if (!tokenString && this.attempts < 10) {
        this.attempts++
        setTimeout(this.checkToken, 300)
      }
    }

    async fetchPreferedClinic(tokenString) {
      if (!localStorage.getItem('pc') || localStorage.getItem('pc') == 'undefined') {
        await fetch(`${window.locations.api_url}/customer/preferred-clinic`, {
          method: 'GET',
          headers: {
            'Authorization': 'Bearer ' + tokenString,
          }
        })
          .then(response => {
            if (response.status === 200) {
              return response.json();
            } else {
              return null;
            }
          })
          .then(data => {
            if (!data) { return }
            this.prefLocation = JSON.parse(data.locationId);
          })
          .catch(error => {
            console.error(error);
          });
      } else {
        this.prefLocation = localStorage.getItem('pc');
      }
    }

    async getLocations() {
      return await fetch(`${window.locations.api_url}/locations?lang=${window.locations.language}`)
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error('Failed to fetch locations');
          }
        })
        .then(resultLocations => {
          let locations = resultLocations.features;
          if (!navigator.geolocation) { return }
          locations = resultLocations.features;
          const positionAllowed = (position) => {
            const userLocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            const sortedLocations = resultLocations.features.sort((a, b) => {
              const aDistance = this.calcCrow(userLocation.lat, userLocation.lng, a.geometry.coordinates[1], a.geometry.coordinates[0]);
              const bDistance = this.calcCrow(userLocation.lat, userLocation.lng, b.geometry.coordinates[1], b.geometry.coordinates[0]);
              return aDistance - bDistance;
            });
            locations = sortedLocations;
            // renderListLocation(sortedLocations);
          }
          const positionDenied = () => {
            locations = resultLocations.features;
          }
          navigator.geolocation.getCurrentPosition(positionAllowed, positionDenied);
          const closedLocations = [
            '580', '144', '169', '230', '252', '335', '348', '357', '364', '4045', '4049', '429', '441', '4501', '4503',
            '4504', '4505', '4506', '4508', '4509', '4511', '4512', '4513', '4514', '4516', '4517', '4519', '4521',
            '4522', '455', '505', '507', '525', '538', '562', '579', '614', '619', '628', '629', '630', '631', '632',
            '633', '634', '635', '636', '637', '738'
          ];
          return locations.filter(location => !closedLocations.includes(location.id));
        })
        .catch(error => {
          console.error(error);
        });
    }

    getLocation() {
      navigator.permissions.query({ name: 'geolocation' }).then((result) => {
        if (result.state == 'granted' || result.state == 'prompt') {
          navigator.geolocation.getCurrentPosition(this.setPosition.bind(this), this.setPosition.bind(this), {
            enableHighAccuracy: false,
            maximumAge: 30000,
            timeout: 20000
          });
        } else {
          this.report(result.state);
          this.renderListLocation()
          this.renderMarkers()
        }
        result.onchange = () => {
          this.report(result.state)
        }
      });
    }

    report(state) {
      console.log('Permission: ' + state);
    }

    updateCenter(data = this.autocomplete?.getPlace()) {
      this.toggleElements('map')
      this.map.panTo(data.geometry.location)
      this.renderMarkers()
      this.renderListLocation()
    }

    setPosition(geolocationPosition) {
      if (geolocationPosition.coords) {
        localStorage.setItem('geoperm', 'true')
        this.loc = {
          lat: geolocationPosition.coords.latitude,
          lng: geolocationPosition.coords.longitude
        }
      } else {
        localStorage.setItem('geoperm', 'false')
      }
      this.customerLocation = this.loc;
      this.map.setCenter(this.loc);
      this.renderListLocation()
      this.renderMarkers()
    }

    renderMarkers() {
      const locations = this.filterLocations()
      locations.forEach(item => {
        const marker = new google.maps.Marker({
          position: {
            lat: item.geometry.coordinates[1],
            lng: item.geometry.coordinates[0]
          },
          icon: window.locations.marker_svg_url,
          map: this.map
        })
        google.maps.event.addListener(marker, 'click', ((marker, item) => {
          return () => {
            if (this.infowindow) {
              this.infowindow.close()
            }
            this.infowindow = new google.maps.InfoWindow()
            const infoWindowContent = `
              <div class="location-popup">
                <div class="location__header">
                  ${this.renderTitle(item)}
                </div>
                ${this.renderSpecialties(item)}
                <div class="location__meta">
                  ${this.renderPhone(item)}
                  ${this.renderAddress(item)}
                </div>
                ${this.renderPreferredClinic(item)}
                ${this.renderMakePreferred(item)}
                <div class="location__actions">
                  ${this.renderBookingButton(item)}
                  ${this.renderDetailsButton(item)}
                </div>
              </div>
            `
            this.infowindow.setContent(infoWindowContent);
            this.infowindow.open(this.map, marker);
            this.clickTime = Date.now();
          }
        })(marker, item));
      })
    }

    renderListLocation() {
      const locations = this.filterLocations()
      this.list.innerHTML = ''
      this.resultsCount.innerHTML = `${locations.length} Result${locations.length === 1 ? '' : 's'}`
      if (locations && locations.length) {
        const currentLocation = this.loc && this.loc.lat ? this.loc : window.locations.default_location
        locations.sort((a, b) => {
          var aDistance = this.calcCrow(currentLocation.lat, currentLocation.lng, a.geometry.coordinates[1], a.geometry.coordinates[0])
          var bDistance = this.calcCrow(currentLocation.lat, currentLocation.lng, b.geometry.coordinates[1], b.geometry.coordinates[0])
          return aDistance - bDistance
        })
        locations.forEach(item => {
          const locationHtml = `
            <div class="location ${item.properties.location.locationID === Number(this.prefLocation) ? 'location--preferred' : ''}" data-location data-id="${item.properties.location.locationID}">
              <div class="location__header">
                ${this.renderTitle(item)}
                ${this.renderDistance(item)}
              </div>
              ${this.renderSpecialties(item)}
              <div class="location__meta">
                ${this.renderPhone(item)}
                ${this.renderAddress(item)}
              </div>
              <div data-location-pref-status>
                ${this.renderPreferredClinic(item)}
                ${this.renderMakePreferred(item)}
              </div>
              <div class="location__actions">
                ${this.renderBookingButton(item)}
                ${this.renderDetailsButton(item)}
              </div>
            </div>
          `
          this.list.innerHTML += locationHtml
        })
      } else {
        const locationHtml = `
          <div class="location location--no-locations text-center">
            <div class="location__title">
              ${window.locations.text.no_locations}
            </div>
          </div>
        `
        this.list.innerHTML = locationHtml
      }
    }

    renderTitle(item) {
      return `
        <h2 class="location__title" data-id="${item.properties.location.name}">
          <a href="${window.location.pathname.includes('/en/') ? item.properties.location.webpage : item.properties.location.webpage?.replace('/en/', '/')}">
            ${item.properties.location.name}
          </a>
        </h2>
      `
    }

    renderAddress(item) {
      return `
        <div class="location__address">
          <p class="location__street-address">
            ${item.properties.location.address.addressLine1},
          </p>
          <span class="location__city">
            ${item.properties.location.address.town ? item.properties.location.address.town : ''}${!item.properties.location.address.province ? '' : ','}
          </span>
          <span class="location__province">
            ${item.properties.location.address.province ? item.properties.location.address.province : ''}
          </span>
        </div>
      `
    }

    renderDistance(item) {
      if (localStorage.getItem("geoperm") == "false") { return '' }
      if (isNaN(Number(this.calcCrow(this.loc.lat, this.loc.lng, item.geometry.coordinates[1], item.geometry.coordinates[0])))) { return '' }
      return `
          <span class="location__distance">
            ${parseInt(this.calcCrow(this.loc.lat, this.loc.lng, item.geometry.coordinates[1], item.geometry.coordinates[0])) + 'km'}
          </span>
        `
    }

    renderSpecialties(item) {
      if (!item.properties.location.specialties) { return '' }
      return `
          <div class="location__badges">
            <div class="location__badge">
              ${item.properties.location.specialties}
            </div>
          </div>
        `
    }

    renderPhone(item) {
      if (!item.properties.location.phoneNumber) { return '' }
      return `
          <div class="location__phone" data-id="${item.properties.location.phoneNumber}">
            <a href="tel:${item.properties.location.phoneNumber}">
              ${formatPhoneNumber(item.properties.location.phoneNumber)}
            </a>
          </div>
        `
    }

    renderPreferredClinic(item) {
      if (item.properties.location.locationID != this.prefLocation || !window.locations.is_customer) { return '' }
      return `
          <div class="location__pref-clinic">
            <span class="location__pref-clinic-label">${window.locations.text.preferred_clinic}</span>
          </div>
        `
    }

    renderBookingButton(item) {
      const apptUrl = item.properties.location.company.toUpperCase() == 'FYIDOCTORS'
        ? 'https://fyidoctors.com/pages/book-an-appointment?locationId='
        : item.properties.location.webschedulerEnabled
          ? 'https://visique.com/pages/rendez-vous?locationId='
          : 'https://visique.com/pages/demander-un-rendez-vous?locationId='
      return `
        <a id="bookingButton" href="${apptUrl}${item.properties.location.locationID}" class="btn btn--secondary">
          ${window.locations.text.book_appointment}
        </a>
      `
    }

    renderDetailsButton(item) {
      return `
        <a href="${window.location.pathname.includes('/en/') ? item.properties.location.webpage : item.properties.location.webpage?.replace('/en/', '/')}" class="btn btn--primary btn--outline">
          ${window.locations.text.view_details}
        </a>
      `
    }

    renderMakePreferred(item) {
      if (!window.locations.is_customer || item.properties.location.locationID === Number(this.prefLocation)) { return '' }
      return `
        <location-pref-button class="location__make-preferred-wrapper" data-location-id="${item.properties.location.locationID}">
          <button
            type="button"
            class="location__make-preferred"
            data-prefer-this-location
          >
            ${window.locations.text.make_preferred_clinic}
          </button>
        </location-pref-button>
      `
    }

    filterLocations() {
      const center = this.map.getCenter()
      if (!center) { return this.allLocations }
      const filterLocations = this.allLocations.filter(item => {
        return this.calcCrow(center.lat(), center.lng(), item.geometry.coordinates[1], item.geometry.coordinates[0]) <= this.range / 1000
      })

      return filterLocations
    }

    handleOptionalRedirect() {
      const urlParams = new URLSearchParams(window.location.search);
      const r = urlParams.get('continueTo');

      if (r) {
        setTimeout(() => {
          window.location.href = r.replace("%2F", "?").replace("%3D", "=");
        }, 1000);
      }
    }

    toRad(value) {
      return value * Math.PI / 180;
    }

    calcCrow(lat1, lon1, lat2, lon2) {
      var R = 6371; // km
      var dLat = this.toRad(lat2 - lat1);
      var dLon = this.toRad(lon2 - lon1);
      var lat1 = this.toRad(lat1);
      var lat2 = this.toRad(lat2);

      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c;
      return d;
    }

    updatePreferredClinic(locationID, parentEl) {
      const token = localStorage.getItem('LRTokenKey');
      const body = JSON.stringify({ 'locationId': locationID });

      fetch(`${window.locations.api_url}/customer/preferred-clinic`, {
        method: "POST",
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": "application/json; charset=utf-8"
        },
        body: body
      })
        .then(response => {
          if (response.status === 200) {
            return response.json()
          } else {
            throw new Error("Request failed")
          }
        })
        .then(result => {
          var data = result.locationId
          localStorage.setItem('pc', data)
          this.prefLocation = data
          this.removeOldPreferredLocationEl()
          this.updatePreferredLocationEl(locationID, parentEl)
          this.renderMarkers()
          setTimeout(() => {
            this.handleOptionalRedirect()
          }, 50)
        })
        .catch(error => {
          console.error(error)
        })
    }

    removeOldPreferredLocationEl() {
      const oldPrefLocation = [...this.querySelectorAll('[data-location]')].find(location => location.classList.contains('location--preferred'))
      if (!oldPrefLocation) { return }
      const item = this.allLocations.find(location => location.properties.location.locationID === Number(oldPrefLocation.dataset.id))
      const prefEl = oldPrefLocation.querySelector('[data-location-pref-status]')

      oldPrefLocation.classList.toggle('location--preferred', item.properties.location.locationID === Number(this.prefLocation))
      prefEl.innerHTML = `
        ${this.renderPreferredClinic(item)}
        ${this.renderMakePreferred(item)}
      `
    }

    updatePreferredLocationEl(locationID, parentEl) {
      const item = this.allLocations.find(location => location.properties.location.locationID === Number(locationID))
      const prefEl = parentEl.querySelector('[data-location-pref-status]')

      prefEl.innerHTML = `
        ${this.renderPreferredClinic(item)}
        ${this.renderMakePreferred(item)}
      `
      parentEl.classList.toggle('location--preferred', item.properties.location.locationID === Number(this.prefLocation))
    }

    async initMap(locationCenter = window.locations.default_location) {
      this.map = new google.maps.Map(this.mapEl, {
        center: locationCenter,
        zoom: 10,
        mapTypeControl: false, // Hide the Satellite view toggle
        streetViewControl: false, // Hide the Street View option
        fullscreenControl: false, // Hide the Fullscreen option
      })

      try {
        const res = await fetch(window.locations.map_json_url)
        if (!res.ok) { throw new Error(res.statusText) }

        const data = await res.json()
        this.map.setOptions({ styles: data })
      } catch (err) {
        console.error(err)
      }

      this.map.addListener('center_changed', () => {
        if (Date.now() > (this.clickTime + 1000)) {
          this.renderMarkers()
          this.renderListLocation()
        }
      })
    }
  })
})();

(() => {
  if (typeof window.customElements.get('location-pref-button') !== 'undefined') { return }
  window.customElements.define('location-pref-button', class LocationsPrefButton extends HTMLElement { // eslint-disable-line
    constructor() {
      super()
      this.button = this.querySelector('[data-prefer-this-location]')
      this.parentList = this.closest('locations-section')
      this.init()
    }

    init() {
      if (!this.button || !this.parentList) { return }
      this.button.addEventListener('click', () => {
        const parentEl = this.closest('[data-location]')
        this.parentList.updatePreferredClinic(this.dataset.locationId, parentEl)
      })
    }
  })
})();